import React, { useMemo } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { Header } from './header';
import { AUTO_BIDDING_FEATURE_IDS } from '../constants';

const StepWrapperInternal = (props) => {
  const {
    coupon, selectedCampaigns, children, onClose, i18n,
  } = props;

  const areCampaignsSelected = useMemo(() => _.isArray(selectedCampaigns) && selectedCampaigns.length > 0, [selectedCampaigns]);

  const headerText = useMemo(() => {
    switch (coupon.FeatureId) {
      case AUTO_BIDDING_FEATURE_IDS.MAX_CLICKS:
        return areCampaignsSelected ?
          i18n.getString(_TL_('Maximize clicks is applied to your selected campaigns')) :
          i18n.getString(_TL_('Maximize clicks is applied to all your campaigns'));
      case AUTO_BIDDING_FEATURE_IDS.MAX_CONVERSIONS:
        return areCampaignsSelected ?
          i18n.getString(_TL_('Maximize conversions is applied to your selected campaigns')) :
          i18n.getString(_TL_('Maximize conversions is applied to all your campaigns'));
      default:
        return '';
    }
  }, [areCampaignsSelected, coupon.FeatureId, i18n]);

  return (
    <>
      <Header text={headerText} onCloseButtonClick={onClose} />
      {children}
    </>
  );
};

StepWrapperInternal.propTypes = {
  children: PropTypes.node.isRequired,
  coupon: PropTypes.shape({
    FeatureId: PropTypes.number.isRequired,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  selectedCampaigns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export const StepWrapperCompletionConfirmation = withI18nConsumer(StepWrapperInternal);
